import React, { JSX, useState } from "react";
import { Alert, TableCell } from "@mui/material";
import { ErrorBoundary } from "@platform/design-system";

import { HeaderSectionTitle } from "../table/rows";
import { StyledTableRow } from "../styled-components";

interface CollapsableSectionProps {
  numberOfColumns: number;
  title: string;
  children: React.ReactNode;
  hasSeparator?: boolean;
}

const Fallback = ({ colSpan }: { colSpan: number }): JSX.Element => (
  <StyledTableRow>
    <TableCell colSpan={colSpan}>
      <Alert severity="error">
        Something went wrong. We can&apos;t display this section.
      </Alert>
    </TableCell>
  </StyledTableRow>
);

const CollapsableSection: React.FC<CollapsableSectionProps> = ({
  title,
  numberOfColumns,
  children,
  hasSeparator = true,
}) => {
  const [isOpen, setIsOpen] = useState(true);
  return (
    <>
      <HeaderSectionTitle
        colSpan={(numberOfColumns || 1) + 1}
        title={title}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        hasSeparator={hasSeparator}
      />
      {isOpen && (
        <ErrorBoundary fallback={() => Fallback({ colSpan: numberOfColumns })}>
          {children}
        </ErrorBoundary>
      )}
    </>
  );
};

export default CollapsableSection;
